var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSmile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#374151",
  d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#374151",
  d: "M14.829 14.828a4.1 4.1 0 0 1-1.272.858 4 4 0 0 1-4.875-1.45l-1.658 1.119a6.1 6.1 0 0 0 1.621 1.62 6 6 0 0 0 2.148.903 6 6 0 0 0 2.415 0 6 6 0 0 0 2.148-.903c.313-.212.612-.458.886-.731.272-.271.52-.571.734-.89l-1.658-1.118a4 4 0 0 1-.489.592M8.5 12a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m6.993-.014a1.493 1.493 0 1 0 0-2.986 1.493 1.493 0 0 0 0 2.986"
})));
export default SvgSmile;